import React, { useState, useEffect } from 'react'
import CategoriesFull from '../Component/CategoriesFull'
import { Grid, Container } from '@mui/material'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import SubFooter from '../Component/SubFooter'
import axios from 'axios'
import config from '../config'

function TopChart() {
  const [productList, setProductList] = useState([])
  useEffect(() => {
    axios
      .get(
        `${config.url}/products?sort=desc&sortBy=total_download&limit=10`,
        config.token
      )
      .then((res) => {
        setProductList(res.data.data)
      })
  }, [])

  return (
    <React.Fragment>
      <Header />
      <Container maxWidth='xl' sx={{ mt: '30px', mb: '30px' }}>
        <Grid container sx={{ paddingTop: '20px' }}>
          <Grid item xs={1} />
          <Grid item xs={10} container>
            {productList.map((value, idx) => (
              <Grid item xs={12} sm={6} lg={6} key={idx}>
                <CategoriesFull data={value} />
              </Grid>
            ))}
          </Grid>
          <Grid item xs={1} />
        </Grid>
      </Container>
      <Footer />
      <SubFooter />
    </React.Fragment>
  )
}

export default TopChart
